export default {
  'SET_SCHEDULES'(state, data) {
    state.schedules = data;
  }
};